import { z } from "zod";

const SafeConfigSchema = z.object({
	// DCS3
	REACT_APP_DCS_ENDPOINT: z.string().url(),
	REACT_APP_DCS_V3_ENDPOINT: z.string().url(),
	REACT_APP_DCS_CLIENT: z.string(),
	// EOS
	REACT_APP_EOS_BRAND: z.string().optional().default("L"),
	// TODO: Revisit removing .url
	REACT_APP_EOS_ENDPOINT: z.string().catch(""),
	REACT_APP_EOS_OAUTH_API_ENDPOINT: z.string().catch(""),
	REACT_APP_EOS_V2_SERVICE_MANAGEMENT_ENDPOINT: z.string().url(),
	REACT_APP_EOS_V2_VEHICLE_HEALTH_ENDPOINT: z.string().url(),
	REACT_APP_EOS_V2_VEHICLE_INFO_ENDPOINT: z.string().url(),
	REACT_APP_EOS_V2_VEHICLE_MAINTENANCE_ENDPOINT: z.string().url(),
	REACT_APP_EOS_V2_VEHICLE_MANAGEMENT_ENDPOINT: z.string().url(),
	REACT_APP_EOS_V2_VEHICLE_SUBSCRIPTION_ENDPOINT: z.string().url(),
	// reCaptcha
	REACT_APP_RECAPTCHA_CONSUMER: z.string().optional().default("LD"),
	REACT_APP_RECAPTCHA_KEY: z.string().catch(""),
	// Common
	REACT_APP_REFERRER_URL: z
		.string()
		.optional()
		.default(window.location.hostname),
	NODE_ENV: z.enum(["development", "production"]),

	// TODO: Add rest of config keys
});

export default SafeConfigSchema;
